export default {"src":"/_next/static/media/linkedin.ccc856ff.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};